module.exports = __webpack_public_path__ + "static/img/aa6.15e7e1ff.png";